import LocalizedStrings from 'localized-strings';

interface CreateNewTransferSuccessLocalizedType {
  internal: {
    title: string;
    description: string;
  };
  yourMainAccount: string;
}

const locales = new LocalizedStrings<CreateNewTransferSuccessLocalizedType>({
  en: {
    internal: {
      description: "You've just sent **{amount}** from **{from}** to **{to}**.",
      title: 'Transfer completed!',
    },
    yourMainAccount: 'your main account',
  },

  fr: {
    internal: {
      description:
        'Vous avez envoyé **{amount}** depuis **{from}** vers **{to}**.',
      title: 'Virement effectué !',
    },
    yourMainAccount: 'votre compte principal',
  },
} as const);

export default locales;
